var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0258 13.188L21.0137 13.212C21.0622 12.816 21.1108 12.408 21.1108 12C21.1108 11.592 21.0744 11.208 21.0258 10.812L21.0379 10.836L24 8.532L21.0501 3.468L17.566 4.86L17.5781 4.872C16.9469 4.392 16.2549 3.984 15.5023 3.672H15.5144L14.956 0H9.04401L8.50986 3.684H8.522C7.76935 3.996 7.07739 4.404 6.44613 4.884L6.45827 4.872L2.96206 3.468L0 8.532L2.96206 10.836L2.9742 10.812C2.92565 11.208 2.88923 11.592 2.88923 12C2.88923 12.408 2.92564 12.816 2.98634 13.212L2.9742 13.188L0.424886 15.168L0.0242795 15.48L2.9742 20.52L6.47041 19.14L6.44613 19.092C7.08953 19.584 7.78149 19.992 8.54628 20.304H8.50986L9.05615 24H14.9439C14.9439 24 14.9803 23.784 15.0167 23.496L15.478 20.316H15.4659C16.2185 20.004 16.9226 19.596 17.566 19.104L17.5417 19.152L21.0379 20.532L23.9879 15.492C23.9879 15.492 23.8179 15.348 23.5873 15.18L21.0258 13.188ZM11.9939 16.2C9.65099 16.2 7.74507 14.316 7.74507 12C7.74507 9.684 9.65099 7.8 11.9939 7.8C14.3369 7.8 16.2428 9.684 16.2428 12C16.2428 14.316 14.3369 16.2 11.9939 16.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.ac94d45ffe3798eddb54e96aeea5fdc6.svg";
export { ForwardRef as ReactComponent };